import { render, staticRenderFns } from "./MailboxLayout.vue?vue&type=template&id=3c4e1da4&scoped=true&"
import script from "./MailboxLayout.vue?vue&type=script&lang=js&"
export * from "./MailboxLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4e1da4",
  null
  
)

export default component.exports